<template>
    <div class="row">
        <div class="col-lg-3">
            <div class="map__section">
                <h3 class="headingMain">HotelMapping Verification API (HotelCode)</h3>
                <p class="subheadingMain">Enter Details Here To Verify HotelMapping</p>
                <hr>
                <div class="form__map">
                    <div class="form__group dropdown">
                        <div class="input-field">
                            <label class="boxBread">Select Suppliers</label>
                            <div class="dropdown" :class="{ open: isDropdownOpen }">
                                <div class="dropdown-toggle" @click="toggleDropdown">
                                    <span v-if="selectedSupplier.length">
                                        {{ selectedSupplier.join(', ') }}
                                    </span>
                                    <span v-else>Select Suppliers<i class="arrow"></i></span>
                                </div>
                                <ul class="dropdown-menu" v-if="isDropdownOpen">
                                    <!-- Select All Checkbox -->
                                    <li class="newator">
                                        <input type="checkbox" class="checksocks" id="selectAll"
                                            :checked="isAllSelected" @change="toggleSelectAll" />
                                        <p class="basicname" for="selectAll">Select All</p>
                                    </li>
                                    <!-- Individual Country Checkboxes -->
                                    <li v-for="supplier in supplierData" :key="supplier" class="newator">
                                        <input type="checkbox" class="checksocks" :id="supplier" :value="supplier"
                                            v-model="selectedSupplier" @change="getcustompolygonlist" />
                                        <p class="basicname" :for="supplier">{{ supplier }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form__group">
                        <div class="input-field">
                            <b-form-select v-model="selectedSupplier" class="form-control" :options="supplierData"></b-form-select>
                            <label>Select Supplier</label>
                        </div>
                    </div> -->
                    <div class="form__group">
                        <div class="input-field">
                            <b-form-input type="text" v-model="selectedValue" @keyup.enter="applymapfilter" required
                                spellcheck="false" autocomplete="off" list="optionsList"></b-form-input>
                            <b-form-datalist id="optionsList" v-if="showDatalist" :options="cityData"></b-form-datalist>
                            <label>Enter HotelCode/SupplierCode</label>
                        </div>
                    </div>
                </div>
                <div class="navigation__filter text-end">
                    <b-button @click="applymapfilter">Show Data &nbsp;</b-button>
                </div>
                <div class="close__map__filter" @click="showfilter = !showfilter"><b-icon icon="list"
                        class="trans90"></b-icon></div>
            </div>
        </div>
        <div class="col-lg-9 p-4">
            <div class="card p-2 baseheight">
                <div v-if="loading" >
                    <div class="loader"></div>
                    <h3 align="center" v-if="loading" >Loading Data...</h3>
                </div>
                <div v-if="!loading">
                    <h4>Response data:</h4>
                    <!-- <pre>{{ hoteldetails[0].length }}</pre> -->
                    <!-- <pre>{{ hoteldetails}}</pre> -->
                    <div v-for="(hotel, index) in hoteldetails" :key="index" class="mb-4">
                        <h5 class="mb-2">Hotel {{ index + 1 }}</h5>

                        <b-table
                            :items="transformHotelDetails(hotel,hoteldetails1[index])"
                            :fields="['Field', 'Value','Value2']"
                            striped
                            hover
                            small
                            responsive="sm"
                        >
                            <template #cell(Field)="data">
                            <strong>{{ data.value }}</strong>
                            </template>
                        </b-table>
                    </div>
                    <!-- <b-table
                        :items="verticalHotelDetails"
                        :fields="['Field', 'Value']"
                        striped
                        hover
                        responsive="sm"
                        >
                        <template #cell(Field)="data">
                            <strong>{{ data.value }}</strong>
                        </template>
                    </b-table> -->
                    <!-- <b-table :items="hoteldetails" :fields="hoteldetailsColumns" striped hover responsive="sm">
                    <template v-slot:cell()="data">
                        <span>{{ data.value }}</span>
                    </template>
                    </b-table> -->
                    <!-- <table v-if="hoteldetails.length" border="1" cellpadding="5">
                        <thead>
                            <tr>
                            <th v-for="(value, key) in hoteldetails" :key="key">{{ key }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td v-for="(value, key) in hoteldetails" :key="key">{{ value }}</td>
                            </tr>
                        </tbody>
                    </table> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const userType = localStorage.getItem('userType');
</script>

<script>
import axios from '@axios'
import GoogleMap from '../googlemap/GoogleMap.vue'
import {
    BButton,
    BFormInput,
    // BFormSelect,
    BPopover,
} from 'bootstrap-vue'

export default {
    data() {
        return {
            isDropdownOpen: false,
            selectedSupplier: [],
            selectedOption: "Suppliers Data",
            loading: false,
            selectedHotelname: null,
            // selectedOption: "Hotels Master",
            selectedValue: null,
            // selectedSupplier: null,
            min_lat: '',
            max_lat: '',
            min_long: '',
            max_long: '',
            showfilter: false,
            showfilter2: true,
            supplierData: [],
            hoteldetails: null,
            hoteldetails1:null,
            columndata:null,
        }
    },
    components: {
        BFormInput,
        BButton,
        // BFormSelect,
    },
    methods: {
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },

        closeDropdown() {
            this.isDropdownOpen = false;
        },
        handleClickOutside(event) {
            const dropdown = this.$el.querySelector('.dropdown');
            if (!dropdown.contains(event.target)) {
                this.closeDropdown();
            }
        },
        toggleSelectAll(event) {
            if (event.target.checked) {
                this.selectedSupplier = [...this.supplierData];
            } else {
                this.selectedSupplier = [];
            }
            this.getcustompolygonlist();
        },
        callMethodFromOtherComponent() {
            GoogleMap.openWindow();
        },
        countryGetList: function () {
            axios.post('/supplier', {
            }).then(response => {
                this.supplierData = response.data
            }).catch(error => {
                console.log("Something went wrong in countryGetList()")
            })
        },
        applymapfilter() {
            this.loading=true,
            axios.post('/datamatch', {
                supplier: this.selectedSupplier,
                suppliercode: this.selectedValue,
            }, {
            }).then(response => {
                this.loading=false,
                this.hoteldetails = response.data.data.data2
                this.hoteldetails1= response.data.data.data1
                console.log(this.hoteldetails1)
                this.hoteldetailsColumns = response.data.data.columns
                console.log(response,"this is the type of",this.hoteldetails)
                // this.columndata = response.data.data.columns


            }).catch(error => {
                this.showloader = true
                if (this.selectedValue != null && this.selectedCountry != null && this.setpolygondata == null) {
                    document.getElementById("alertshowhide").classList.toggle("active__alert")
                    this.alertmsg = "Special Character Not allowed"
                    setTimeout(function () {
                        this.showalertmsg = false
                        document.getElementById("alertshowhide").classList.toggle("active__alert")
                    }, 8000)
                    // this.showfilter = !this.showfilter
                    // this.showfilter2 = !this.showfilter2
                    // this.showGoogleMap = false
                    this.showloader = false
                } else if (this.selectedValue == null && this.selectedCountry == null) {
                    document.getElementById("alertshowhide").classList.toggle("active__alert")
                    this.alertmsg = "City and Country not selected"
                    setTimeout(function () {
                        this.showalertmsg = false
                        document.getElementById("alertshowhide").classList.toggle("active__alert")
                    }, 8000)
                    // this.showfilter = !this.showfilter
                    // this.showfilter2 = !this.showfilter2
                    // this.showGoogleMap = false
                    this.showloader = false
                } else if (this.selectedValue == null) {
                    document.getElementById("alertshowhide").classList.toggle("active__alert")
                    this.alertmsg = "City not selected"
                    setTimeout(function () {
                        this.showalertmsg = false
                        document.getElementById("alertshowhide").classList.toggle("active__alert")
                    }, 8000)
                    // this.showfilter = !this.showfilter
                    // this.showfilter2 = !this.showfilter2
                    // this.showGoogleMap = false
                    this.showloader = false
                } else if (this.selectedCountry == null) {
                    document.getElementById("alertshowhide").classList.toggle("active__alert")
                    this.alertmsg = "Country not selected"
                    setTimeout(function () {
                        this.showalertmsg = false
                        document.getElementById("alertshowhide").classList.toggle("active__alert")
                    }, 8000)
                    // this.showfilter = !this.showfilter
                    // this.showfilter2 = !this.showfilter2
                    this.showGoogleMap = false
                    this.showloader = false
                } else {
                    document.getElementById("alertshowhide").classList.toggle("active__alert")
                    this.alertmsg = "Suppliers Data Not Found"
                    setTimeout(function () {
                        this.showalertmsg = false
                        document.getElementById("alertshowhide").classList.toggle("active__alert")
                    }, 8000)
                    // this.showfilter = !this.showfilter
                    // this.showfilter2 = !this.showfilter2
                    this.showGoogleMap = true
                    this.showloader = false
                }
            })
        },
        closelist() {
            this.showfilter2 = !this.showfilter2
            this.showfilter = !this.showfilter
        },
        transformHotelDetails(hotel,otherdata={}) {
            return Object.entries(hotel).map(([key, value]) => ({
            Field: key,
            Value: value,
            Value2: otherdata[key] ?? '-',
            }));
        }
    },
    // computed: {
    //     verticalHotelDetails() {
    //         const hotel = this.hoteldetails || {};
    //         return Object.entries(hotel).map(([key, value]) => ({
    //         Field: key,
    //         Value: value
    //         }));
    //     }
    // },
    mounted() {
        this.countryGetList();
    }
}

</script>

<style>
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  animation: spin 1s linear infinite;
  margin: 20px auto;
  margin-top: 200px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.select {
    width: 100%;
    height: 50px;
    border-radius: 6px;
    font-size: 15px;
    padding: 0 15px;
    border: 2px solid #378ad6;
    background: transparent;
    color: #000;
    outline: none;
}

.infogap {
    margin-left: 10px;
}

input:focus~label,
input:valid~label,
select:focus~label,
select:valid~label {
    top: 0;
    left: 15px;
    font-size: 13px;
    padding: 0 2px;
    background: #fff;
}

.checkHeight {
    height: 12px !important;
}

.margBase {
    margin: 0 0 1rem 0;
}

.checkHeight input:checked~.checkmark {
    background-color: #2196F3 !important;
}

.input-field input,
.input-field select {
    width: 100%;
    height: 50px;
    border-radius: 6px;
    font-size: 15px;
    padding: 0 15px;
    border: 2px solid #378ad6;
    background: transparent;
    color: #000;
    outline: none;
}

.checkmark {
    color: rgb(29, 81, 224);
    margin-left: 10px;
}

.bg-under {
    background-color: #00ae08 !important;
}

.bg-outside {
    background-color: #c81b00 !important;
}

.bg-info {
    background-color: blue !important;
}

.city-text {
    text-transform: uppercase;
}

.green {
    color: #00ae08;
}

.red {
    color: #c81b00;
}

.blue {
    color: blue
}

input[type="checkbox"] {
    transform: scale(1.5);
}

.destination_save {
    width: 140px;
    margin-left: 10px;
    margin-right: 10px;
}

.look {
    color: black;
}

.search1 {
    height: 35px;
    width: 290px;
}

.red {
    color: #c81b00;
}

.black {
    color: black;
}
.baseheight{
    height:80vh !important;
    overflow-y: auto;
}
table th {
    background-color: #378ad6 !important;
    color: #fff !important;
    font-size: 13px;
}
</style>